import { makeStyles, createStyles } from 'styles/utils';

export const useStyles = makeStyles(theme => createStyles({
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 3, 0, 3)
  },
}));